import { useEffect, useState } from "react";
import "../../styles/visualization/controls.css";

const Controls = ({
  setDebouncedSearch,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  sortOptions,
}) => {
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(search), 500);
    return () => clearTimeout(handler);
  }, [search]);

  return (
    <div className="controls">
      <input
        type="text"
        placeholder="Search visualizations..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="controls-search"
      />

      <div className="controls-sort">
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="controls-select"
        >
          {Object.entries(sortOptions).map(([key, val], idx) => (
            <option value={val} key={idx}>
              {key}
            </option>
          ))}
        </select>

        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          className="controls-select"
        >
          <option value="desc">Desc</option>
          <option value="asc">Asc</option>
        </select>
      </div>
    </div>
  );
};

export default Controls;
